// import React, { useEffect, useState } from 'react';
// import './Slider.css';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { toast } from 'react-toastify';

// const Slider = () => {
//   const [slides, setSlides] = useState([]);
//   const [index, setIndex] = useState(0);
//   const [showButton, setShowButton] = useState(true);
//   const navigate = useNavigate();

//   useEffect(() => {
//     axios.get("/api/sliders")
//       .then((res) => setSlides(res.data))
//       .catch((err) => console.error("Failed to fetch sliders", err));
//   }, []);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setIndex(prev => (prev + 1) % slides.length);
//     }, 8000);
//     return () => clearInterval(interval);
//   }, [slides]);

//   useEffect(() => {
//     const timer = setTimeout(() => setShowButton(false), 7000);
//     return () => clearTimeout(timer);
//   }, []);

//   const prevSlide = () => {
//     setIndex((prev) => (prev - 1 + slides.length) % slides.length);
//   };

//   const nextSlide = () => {
//     setIndex((prev) => (prev + 1) % slides.length);
//   };

//   if (slides.length === 0) return null;

//   return (
//     <div className="slider-container">
//       <div className="slider">
//         <button className="nav-btn left" onClick={prevSlide}>&lt;</button>
        
//        <img
//   src={`${slides[index].imageUrl}`}
//   alt={`slide-${index}`}
//   className="slider-image"
// />


//         <button className="nav-btn right" onClick={nextSlide}>&gt;</button>

//         <div className="slider-content">
//           <h2 className="slider-text">{slides[index].text}</h2>
//           {index === 0 && showButton && (
//             <button className="slider-btn" onClick={() => navigate('/contact')}>
//               Join Now
//             </button>
//           )}
//         </div>
//       </div>  

//       <div className="slider-dots">
//         {slides.map((_, i) => (
//           <span
//             key={i}
//             className={`dot ${i === index ? 'active' : ''}`}
//             onClick={() => setIndex(i)}
//           >___</span>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Slider;



import React, { useEffect, useState } from "react";
import "./Slider.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { motion } from "framer-motion";
import "swiper/css";
import "swiper/css/pagination";

const Slider = () => {
  const [slides, setSlides] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [showButton, setShowButton] = useState(true);
  const navigate = useNavigate();

  // Animation Variants
  const containerVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, staggerChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  // Fetch slides from backend
  useEffect(() => {
    axios
      .get("/api/sliders")
      .then((res) => setSlides(res.data))
      .catch((err) => console.error("Failed to fetch sliders", err));
  }, []);

  // Hide Join Now after 7 seconds
  useEffect(() => {
    const timer = setTimeout(() => setShowButton(false), 7000);
    return () => clearTimeout(timer);
  }, []);

  if (!slides.length) return null;

  return (
    <section className="hero-slider">
      <Swiper
        modules={[Autoplay, Pagination]}
        loop={true}
        autoplay={{ delay: 4000 }}
        pagination={{ clickable: true }}
        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
        className="hero-swiper"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
           <div
  className="slide-bg"
  style={{
    backgroundImage: `url(${slide.imageUrl})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  }}
>

              {/* Text Content */}
           <motion.div
  className="slide-content"
  variants={containerVariants}
  initial="hidden"
  animate={activeIndex === index ? "visible" : "hidden"}
>
  {/* Title First */}
  {slide.text && (
    <motion.h1 className="slide-title" variants={itemVariants}>
      {slide.text.split("\n").map((line, i) => (
        <React.Fragment key={i}>
          {line}
          <br />
        </React.Fragment>
      ))}
    </motion.h1>
  )}

  {/* Tag After */}
  {slide.tag && (
    <motion.p className="slide-tag" variants={itemVariants}>
      {slide.tag}
    </motion.p>
  )}

  {/* If you want the button last later */}
  {/* {index === 0 && showButton && (
    <motion.button
      className="shop-button"
      variants={itemVariants}
      onClick={() => navigate("/contact")}
    >
      Join Now →
    </motion.button>
  )} */}
</motion.div>


              {/* Overlay Image */}
              {slide.overlayImageUrl && (
                <motion.img
                  src={`${slide.overlayImageUrl}`}
                  alt="Overlay"
                  className="slide-overlay-img"
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={
                    activeIndex === index
                      ? { opacity: 1, scale: 1 }
                      : { opacity: 0, scale: 0.8 }
                  }
                  transition={{ duration: 1.5, ease: "easeOut" }}
                />
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Slider;
